<template>
    <v-dialog v-model="dialogVisible" max-width="600px" >

        <v-card>
            <v-card-title>
                <span v-if="mode== 'create'" class="text-h5">Add User</span>
                <span v-else class="text-h5">Edit User</span>
            </v-card-title>

            



            <v-container >
                <v-form v-model="valid">
                <v-row>
                    <v-col cols="6">
                        <v-text-field 
                            v-model="user.email" 
                            name="email" 
                            label="email" 
                            placeholder="user@domain.com"
                            :rules="[vRules.required, vRules.email]"
                            @keyup.enter="confirm"
                            ></v-text-field>
                    </v-col>
                  
                    <v-col cols="3">
                        <v-text-field 
                            v-model="user.firstName" 
                            name="firstName" 
                            label="First Name" 
                            :rules="[vRules.required]"
                            @keyup.enter="confirm"
                            ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                        <v-text-field 
                            v-model="user.lastName" 
                            name="lastName" 
                            label="Last Name" 
                            :rules="[vRules.required]"
                            @keyup.enter="confirm"
                            ></v-text-field>
                    </v-col>

                </v-row>
            


                </v-form>


            </v-container>

            <v-card-actions class=" d-flex justify-end">
                                    

                                    <v-btn variant="outlined" color="red" @click="close">Close</v-btn>



            </v-card-actions>


        </v-card>
    </v-dialog>
</template>
<style ></style>
<script>


import { ref , computed, reactive, onMounted } from 'vue'
import { isValidEmail, isValidRange } from '@/composables/HelperUtil';




export default {
    props: {
        modelValue: { type: Object, required: true }
    },
    setup(props, { emit }) {

        const dialogVisible = ref(false);
        const valid = ref(false);

        const user = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                
                emit('update:modelValue', value);
            }
        });

        

        function cancel() {
            emit('cancel');
            close();
        }

        function confirm(){
            emit('confirm');
            close();
        }

        function open(){
            dialogVisible.value = true;
        }

        function close(){
            dialogVisible.value = false;
        }

        const vRules=reactive({
            required: (value) => !!value || 'Required.',
            email: (value) => isValidEmail(value) || 'Invalid Email',

        })
       

        return {
            dialogVisible,
            valid,
            vRules,
            confirm,
            cancel,
            open,
            close,
            user
        };
    },
    components: {

    },
    emits: ['confirm', 'cancel', 'created']
}
</script>
